import React, { useState, useEffect } from "react";
import styles from "./CookieBanner.module.css";
import { Link } from "react-router-dom";

const COOKIE_KEY = "cookieConsent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className={styles.cookieBanner}>
      <span className={styles.cookieBannerContent}>
        <CookieIcon />
        <span className={styles.cookieBannerText}>
          На сайте используются cookie-файлы и сервисы аналитики. Продолжая пользоваться сайтом, вы соглашаетесь с{' '}
          <Link
            to="/polzovatelskoe-soglashenie"
            target="_blank"
            rel="noopener noreferrer"
          >
            политикой использования файлов cookie
          </Link>.
        </span>
      </span>
      <button className={styles.cookieBannerBtn} onClick={(e) => { e.stopPropagation(); handleAccept(); }}>
        Понятно
      </button>
    </div>
  );
};

function CookieIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" className={styles.noShrink} xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#fff" fillOpacity="0.13" />
      <path d="M25.5 16.5C25.5 22.0228 21.0228 26.5 15.5 26.5C9.97715 26.5 5.5 22.0228 5.5 16.5C5.5 10.9772 9.97715 6.5 15.5 6.5C15.5 8.5 18.5 8.5 18.5 10.5C18.5 12.5 25.5 12.5 25.5 16.5Z" fill="#fff" fillOpacity="0.7"/>
      <circle cx="13.5" cy="14.5" r="1.5" fill="#10678c" />
      <circle cx="19.5" cy="19.5" r="1" fill="#10678c" />
      <circle cx="15.5" cy="20.5" r="0.7" fill="#10678c" />
    </svg>
  );
}

export default CookieBanner; 